import { Briefcase, ExternalLink, Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

import { api } from "@/api";
import { formatError } from "@/auth";

export function LeadPicker({ projectId, todoId, initial, onSaved }) {
  const [leads, setLeads] = useState(initial || []);
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return undefined; }
    setLoading(true);
    const t = setTimeout(() => api.get("/pipeline/lookup", { params: { q } }).then(({ data }) => setResults(data)).catch(() => setResults([])).finally(() => setLoading(false)), 250);
    return () => clearTimeout(t);
  }, [q]);

  const save = async (next) => {
    try {
      const { data } = await api.patch(`/projects/${projectId}/todos/${todoId}`, { lead_ids: next.map((l) => l.lead_id) });
      setLeads(data.leads || []); onSaved?.();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  const add = (lead) => { setQ(""); setResults([]); if (!leads.some((l) => l.lead_id === lead.lead_id)) save([...leads, lead]); };

  return (
    <div className="pj-leads" data-testid="todo-leads">
      <span className="pj-prop-label"><Briefcase size={15} />Dossiers clients</span>
      <div className="pj-leads-chips">
        {leads.map((l) => (
          <span key={l.lead_id} className="pj-lead-chip" data-testid={`todo-lead-chip-${l.lead_id}`}>
            <Link to={`/pipeline?lead=${l.lead_id}`} title="Ouvrir le dossier" data-testid={`todo-lead-open-${l.lead_id}`}>{l.title}<ExternalLink size={11} /></Link>
            <button type="button" onClick={() => save(leads.filter((x) => x.lead_id !== l.lead_id))} aria-label="Retirer" data-testid={`todo-lead-remove-${l.lead_id}`}><X size={12} /></button>
          </span>
        ))}
      </div>
      <div className="pj-lead-search">
        <Search size={14} />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nom ou nom-prénom du client…" data-testid="todo-lead-search" />
        {q.trim().length >= 2 && (
          <div className="pj-lead-results" data-testid="todo-lead-results">
            {loading && !results.length && <p className="pj-muted">Recherche…</p>}
            {!loading && !results.length && <p className="pj-muted" data-testid="todo-lead-noresult">Aucun dossier trouvé.</p>}
            {results.map((r) => (
              <button key={r.lead_id} type="button" onClick={() => add(r)} data-testid={`todo-lead-result-${r.lead_id}`}>
                <strong>{r.title}</strong><small>{[r.pipeline, r.step, r.owner_name].filter(Boolean).join(" · ")}</small>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
